// src/pages/Home.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import { FaSearch } from "react-icons/fa";

export default function Home() {
  const navigate = useNavigate();

  const restaurants = [
    "Dolci - Drinks",
    "Soup Garden",
    "Origami - Sushi",
    "Origami - Teppanyaki",
    "Qdoba",
    "Atomic Pizzeria",
    "Jamba - Smoothies",
    "1872 - Grill",
  ];

  const handleRestaurantClick = (name) => {
    const encodedName = encodeURIComponent(name); // e.g., "Soup Garden" → "Soup%20Garden"
    navigate(`/bin/${encodedName}`);
  };

  return (
    <div className="flex flex-col items-center justify-start py-10 px-6 min-h-screen bg-[#F5F5D5]">
      {/* Search Bar */}
      <div className="relative w-full max-w-2xl mb-12">
        <FaSearch className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-500 text-lg" />
        <input
          type="text"
          placeholder="Search for an item..."
          className="w-full pl-12 pr-4 py-5 text-xl border border-gray-300 rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-green-700"
        />
      </div>

      {/* Button Grid */}
      <div className="w-full max-w-7xl grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-8">
        {restaurants.map((name, idx) => (
          <button
            key={idx}
            onClick={() => handleRestaurantClick(name)}
            className="w-full h-32 bg-[#234C2C] text-[#F6F8D0] text-2xl font-semibold rounded-2xl shadow-lg hover:bg-green-900 transition duration-200"
          >
            {name}
          </button>
        ))}
      </div>
    </div>
  );
}
